import { render, staticRenderFns } from "./project-member.vue?vue&type=template&id=d5929cc8&scoped=true&"
import script from "./project-member.vue?vue&type=script&lang=js&"
export * from "./project-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5929cc8",
  null
  
)

export default component.exports